import { Component, OnInit, AfterContentChecked, Input } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-smss-card',
  templateUrl: './account-smss-card.component.html',
  styleUrls: ['./account-smss-card.component.scss']
})
export class AccountSmssCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor( private spinnerService: SpinnerService ) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('sms-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('sms-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableSms;
      this.disableCount = this.data.unavailableSms;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('sms-counts-spinner');
    }
  }

}
